import { importCosmosClient } from '@polaris/core/cosmos'
import { generateConfig } from '@quirks/ssr'
import type { QuirksConfigStore } from '@quirks/store'
import {
  cosmostationExtension,
  keplrExtension,
  leapExtension,
  okxExtension,
} from '@quirks/wallets'
import { assets, chain } from 'chain-registry/mainnet/osmosis'

// Set the leap wallet logo to match the wagmi injected wallet icon
Object.defineProperty(leapExtension, 'logoLight', {
  value: 'https://s3.polaris.app/wallets/leap.ico',
  writable: true,
})

/**
 * Now the store is still global but defined in app scope,
 * so we don't depend from external dep injection
 */
let store: QuirksConfigStore

export const getConfig = (cookie: string | undefined | null) => {
  /**
   * Since we can use this function multiple times, this makes sure
   * to only create a single global store
   */
  if (store) {
    return store
  }

  store = generateConfig(
    {
      wallets: [
        keplrExtension,
        leapExtension,
        okxExtension,
        cosmostationExtension,
      ],
      chains: [chain],
      assetsLists: [assets],
      signOptions: {
        // Prevent alternative fee tokens in Keplr for now.
        // This prevents downstream insufficient balance errors if the user happens to swap in the full balance of the fee token that was used.
        preferNoSetFee: true,
      },
      signerOptions: {
        signingStargate: async () => {
          const { registry, aminoTypes } = await importCosmosClient()

          return {
            registry,
            aminoTypes,
          }
        },
      },
    },
    // use default options
    undefined,
    cookie,
  )

  return store
}
